export const LOAD_RULES_COUNTER_WIDGET_DATA_REQUEST = "[DASHBOARD] LOAD_RULES_COUNTER_WIDGET_DATA_REQUEST"; 
export const LOAD_EVENTS_COUNTER_WIDGET_DATA_REQUEST = "[DASHBOARD] LOAD_EVENTS_COUNTER_WIDGET_DATA_REQUEST";
